var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRightArrOn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Feather Icons / chevron-right"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34868 2.01534C6.81359 1.55043 7.56736 1.55043 8.03227 2.01534L15.1751 9.1582C15.64 9.62311 15.64 10.3769 15.1751 10.8418L8.03227 17.9846C7.56736 18.4496 6.81359 18.4496 6.34868 17.9846C5.88377 17.5197 5.88377 16.766 6.34868 16.3011L12.6497 9.99999L6.34868 3.69893C5.88377 3.23402 5.88377 2.48025 6.34868 2.01534Z",
    fill: "#0E6AF4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrOn);
export default __webpack_public_path__ + "static/media/right_arr_on.ef96251d4ebef769c8820298569f58b3.svg";
export { ForwardRef as ReactComponent };